import { ExclamationCircleFilled } from "@ant-design/icons";
import * as React from "react";

import * as styles from "./MfExternalErrorIcon.module.less";

type PropsMfExternalErrorIcon = {
  warning?: boolean;
};

export const MfExternalErrorIcon: React.FC<PropsMfExternalErrorIcon> = ({
  warning,
}) =>
  warning ? (
    <span className={styles.iconWarning}>
      <ExclamationCircleFilled />
    </span>
  ) : (
    <span className={styles.iconError}>
      <ExclamationCircleFilled />
    </span>
  );
